import moment from 'moment';
import { quantile } from 'simple-statistics';

const runMonteCarlo = (iterations, confidence, fn) => {
  const runs = new Array(iterations).fill(0).map(fn);

  return quantile(runs, confidence);
};

export const howLong = (numIssues, issues) => {
  const throughput = Object.values(throughputPerDay(issues));
  return howLongWithThroughput(numIssues, throughput);
};

export const howLongWithThroughput = (numIssues, throughput) => {
  const iterations = 100000;

  return runMonteCarlo(iterations, 0.8, () => {
    let issues = 0;
    let days = 0;
    while (issues < numIssues) {
      const randomThroughput = throughput[Math.floor(Math.random() * throughput.length)];
      issues += randomThroughput;
      days += 1;
    }
    return days;
  });
};

export const howMany = (numDays, issues) => {
  const throughput = Object.values(throughputPerDay(issues));
  return howManyWithThroughput(numDays, throughput);
};

export const howManyWithThroughput = (numDays, throughput) => {
  const iterations = 100000;

  return runMonteCarlo(iterations, 0.2, () => {
    let issues = 0;
    let days = 0;
    while (days < numDays) {
      const randomThroughput = throughput[Math.floor(Math.random() * throughput.length)];
      issues += randomThroughput;
      days += 1;
    }
    return issues;
  });
};

export const throughputPerDay = issues => {
  if (!issues.length) {
    return {};
  }

  const maxChangeDate = moment(issues[0].fields.statuscategorychangedate);
  const minChangeDate = moment(issues[issues.length - 1].fields.statuscategorychangedate);

  const differenceInDays = maxChangeDate.diff(minChangeDate, 'days');

  const buckets = new Array(differenceInDays).fill(0).reduce(
    (acc, curr, index) => {
      const nextDate = minChangeDate.clone().add(index, 'days').format('YYYY-MM-DD');
      return {
        ...acc,
        [nextDate]: 0,
      };
    },
    { [minChangeDate.format('YYYY-MM-DD')]: 0, [maxChangeDate.format('YYYY-MM-DD')]: 0 }
  );

  return issues.reduce((acc, issue) => {
    const changeDay = moment(issue.fields.statuscategorychangedate).format('YYYY-MM-DD');
    return {
      ...acc,
      [changeDay]: acc[changeDay] + 1,
    };
  }, buckets);
};
